import { Box, Text } from '@fozito/common-ui';
import clsx from 'clsx';
import { IBillInfoResData } from 'modules/POS/services/types/bill';
import { memo, useMemo } from 'react';
import styled from 'styled-components';
import { formatCurrency } from 'utils/formatCurrency';
type Props = {
  data: IBillInfoResData | null
  v2?: boolean;
  cardFee?: number;
  total?: number;
};
const DescribePayment = ({ data, v2, cardFee, total = 0 }: Props) => {
  const describePayment = useMemo(() => {
    // const creditPayment = find(data?.payments, o => o.paymentType === PAYMENT_TYPE.CREDIT_CARD);
    return [
      { name: 'Credit Fee', price: cardFee || 0 },
      { name: 'Sale Tax:', price: data?.saleTax || 0 },
      { name: 'Used Tax:', price: data?.useTax || 0 },
      { name: 'Disc. By Item:', price: (data?.discountItem || 0) },
      { name: 'Disc. By Ticket:', price: (data?.discount || 0) },
    ].filter(o => !!o);
  }, [data, cardFee]);

  return (
    <Container className={clsx(v2 && 'v2')}>
      <Box display="flex" flexDirection="column" paddingLeft={24} paddingRight={24} paddingTop={16} marginBottom={16}>
        {!v2 ? <Text className="divider" /> : <Text />}
        <Box className="space-between sub-total" display='flex' alignItems='center' justifyContent='space-between'>
          <Text title_h5_24_semibold>
            Subtotal:
          </Text>
          <Text title_h3_28_semibold>
            {formatCurrency(data?.subTotal)}
          </Text>
        </Box>
        <Text className="divider" />
        <Box display='flex' flexDirection='column' gap={8} marginTop={8}>
          {describePayment.map((item) => {
            return (
              <Box className="space-between describePayment" key={item?.name} display='flex' alignItems='center' justifyContent='space-between'>
                <Text title_h6_20_regular>
                  {item?.name}
                </Text>
                <Text title_h6_20_regular>
                  {formatCurrency(item?.price)}
                </Text>
              </Box>
            );
          })}
        </Box>
      </Box>
      <Box className='total'>
        <Box className="space-between container-total" padding={16} paddingRight={24} paddingLeft={24}>
          <Text title_h5_24_semibold>
            Total
          </Text>
          <Text title_h3_28_semibold>
            {formatCurrency(total)}
          </Text>
        </Box>
      </Box>
    </Container>

  );
};

export default memo(DescribePayment);

const Container = styled.div`
&.v2 {
  .sub-total {
    .sub-total-label {
      color: #1D2129;
      font-family: Poppins;
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }

    .sub-total-value {
      color: #1D2129;
      text-align: right;
      font-family: Poppins;
      font-size: 24px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
  }
  .describePayment {
    .label, .value {
    font-size: 20px;
    }
  }
  .total {
    .container-total {
      background: #fff;
    }
    .total-label {
      color: #1D2129;
      font-family: Poppins;
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
    .total-value {
      color: #1D2129;
      text-align: right;
      font-family: Poppins;
      font-size: 24px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
  }
}
`;
